export default "__VITE_ASSET__DMjC4hSe__"